/**
 * Liste des articles du blog, dans l'ordre d'affichage. Pour ajouter un article : créer le fichier dans ce dossier,
 * puis l'ajouter ici. Il apparaît alors dans le blog, le sitemap et le prérendu.
 * Fichier en CommonJS : il est lu par l'application (webpack) et par prerender.js (Node).
 */
const list = [
    require('./facturation-electronique-2026-2027-calendrier-obligations'),
    require('./factur-x-format-facture-electronique'),
    require('./mentions-obligatoires-facture-2026'),
    require('./facture-acompte-facture-finale'),
    require('./devis-mentions-obligatoires-validite-valeur-juridique'),
    require('./facture-avoir-comment-etablir'),
    require('./facture-impayee-relance-penalites-retard'),
    require('./fec-fichier-des-ecritures-comptables'),
    require('./export-comptable-fec-excel-expert-comptable'),
    require('./choisir-logiciel-facturation-tpe-independant'),
    require('./erp-crm-logiciel-facturation-tpe'),
    require('./erp-definition-pgi-modules-tpe-pme'),
    require('./crm-gestion-relation-client-tpe-definition'),
    require('./logiciel-de-facturation-a-quoi-ca-sert'),
    require('./exemple-facture-factur-x-xml')
];

// Nombre de mots d'un texte avec le balisage minimal (**gras**, [lien](url), ==surlignage==)
function words(text) {
    return String(text || '')
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        .replace(/[*=]{2}/g, '')
        .split(/\s+/)
        .filter(Boolean).length;
}

function blockWords(block) {
    if (block.p) return words(block.p);
    if (block.h3) return words(block.h3);
    if (block.note) return words(block.note);
    if (block.quote) return words(block.quote);
    if (block.ul) return block.ul.reduce((sum, item) => sum + words(item), 0);
    if (block.ol) return block.ol.reduce((sum, item) => sum + words(item), 0);
    if (block.table) {
        const cells = [].concat(block.table.head, ...block.table.rows);
        return cells.reduce((sum, cell) => sum + words(cell), 0);
    }
    return 0;
}

list.forEach(article => {
    article.path = '/blog/' + article.slug;
    article.wordCount = words(article.lead)
        + article.sections.reduce((sum, section) => sum + words(section.h2) + section.blocks.reduce((s, b) => s + blockWords(b), 0), 0)
        + (article.faq || []).reduce((sum, item) => sum + words(item.q) + words(item.a), 0);
    article.readingMinutes = Math.max(1, Math.round(article.wordCount / 200));
});

module.exports = list;
